import { createContext, useContext } from 'react';

export type ToastType = 'success' | 'error' | 'warning' | 'info' | 'progress';

export interface Toast {
    id: string;
    message: string;
    type: ToastType;
    persistent?: boolean;
    duration?: number;
    progress?: number;
    onClick?: () => void;
}

export interface ToastContextValue {
    showToast: (
        message: string,
        type?: ToastType,
        options?: { persistent?: boolean; duration?: number; onClick?: () => void },
    ) => string;
    updateToast: (id: string, updates: Partial<Pick<Toast, 'message' | 'progress' | 'type'>>) => void;
    removeToast: (id: string) => void;
    confirmDialog: (message: string, confirmText?: string, cancelText?: string) => Promise<boolean>;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

export const useToast = (): ToastContextValue => {
    const context = useContext(ToastContext);
    if (!context) throw new Error('useToast must be used within ToastProvider');
    return context;
};
